interface FashionInspirationContext {
    token: string;
    nodeName: string;
    locale: string;
}

/**
 * IFrame is used to integrate Fashion Inspiration page and this function is used to pass context to iframe
 * The data that is needed by Fashion Inspiration is transmitted via context - JWT token, current node name and current locale
 */
export const passContextToIFrame = (iFrameId: string, context: FashionInspirationContext): void => {
	const iframe = document.getElementById(iFrameId) as HTMLIFrameElement;
	if (iframe) {
		iframe.contentWindow.postMessage({
			type: "passContext",
			context,
		}, "*");
	}
};
